"use client";

import { Core } from "@faire/design-tokens";
import { SVGIcon } from "@faire/web/slate/icons/SVGIcon";
import { eventsThemeColors } from "@faire/web/slate/Theme/eventsThemeColors";
import { PromotionalEventType } from "@faire/web-api--source/indigofair/common/PromotionalEventType";
import React from "react";

interface IProps extends SVGIcon.IProps {
  /**
   * @default: false, text color is Event Promo Text
   * When set to true, text color is White
   * Sun color is always Event Secondary
   */
  isInverse?: boolean;
  iconColor?: string;
}

export const WinterMarketPrimaryLogo: React.FC<IProps> = ({
  isInverse,
  iconColor,
  ...rest
}) => {
  const textColor = isInverse
    ? Core.text.inverse
    : eventsThemeColors[PromotionalEventType.FAIRE_WINTER_MARKET_2023]
        .promoText;

  const snowflakeColor =
    iconColor ??
    eventsThemeColors[PromotionalEventType.FAIRE_WINTER_MARKET_2023].badgeIcon;
  return (
    <SVGIcon
      width="240"
      height="201"
      viewBox="0 0 240 201"
      fill="none"
      {...rest}
    >
      <path
        d="M4.47829 82.0238H11.9012V55.5602H19.2014V49.9857H11.9012V45.3913C11.9012 42.6347 13.1281 40.6744 16.1341 40.6744C17.4837 40.6744 18.6493 40.9194 19.5082 41.2257V35.4674C18.1585 35.0386 17.0543 34.8549 15.2753 34.8549C8.40446 34.8549 4.47829 38.6529 4.47829 45.6976V49.9857H0.122693V55.5602H4.47829V82.0238Z"
        fill={textColor}
      />
      <path
        d="M35.561 82.6364C40.4687 82.6364 43.2906 80.8599 45.3764 78.1033V82.0238H52.6766V61.0122C52.6766 52.2522 47.0328 49.3118 39.8552 49.3118C32.6777 49.3118 26.7271 52.436 26.1136 59.9095H33.2912C33.6592 56.7241 35.561 54.8863 39.4258 54.8863C43.7814 54.8863 45.2537 57.0304 45.2537 61.3185V62.9724H41.2662C32.0642 62.9724 24.8254 65.6678 24.8254 73.1413C24.8254 79.8185 29.6717 82.6364 35.561 82.6364ZM37.34 77.3069C33.6592 77.3069 32.1869 75.5304 32.1869 72.835C32.1869 68.9145 35.8064 67.6281 41.4502 67.6281H45.2537V70.8135C45.2537 74.9178 41.8797 77.3069 37.34 77.3069Z"
        fill={textColor}
      />
      <path
        d="M67.3276 44.7175C69.7814 44.7175 71.7445 42.8797 71.7445 40.4906C71.7445 38.0403 69.7814 36.2025 67.3276 36.2025C64.8737 36.2025 62.9106 38.0403 62.9106 40.4906C62.9106 42.8797 64.8737 44.7175 67.3276 44.7175ZM63.7081 82.0238H71.1311V49.9857H63.7081V82.0238Z"
        fill={textColor}
      />
      <path
        d="M82.5182 82.0238H89.9411V65.3615C89.9411 58.5618 93.8673 56.4791 100.37 56.4178V49.4956C94.9715 49.5569 91.9655 51.9459 89.9411 55.989V49.9857H82.5182V82.0238Z"
        fill={textColor}
      />
      <path
        d="M122.691 82.6364C130.912 82.6364 136.371 78.9609 137.414 72.2225H130.237C129.685 75.3466 127.354 77.1231 122.875 77.1231C117.354 77.1231 114.287 73.6927 114.041 67.6281H137.537V65.484C137.537 54.0287 130.359 49.3118 122.384 49.3118C113.244 49.3118 106.434 55.9277 106.434 65.8516V66.3417C106.434 76.4493 113.244 82.6364 122.691 82.6364ZM114.164 62.6662C114.9 57.7042 117.906 54.7026 122.384 54.7026C126.985 54.7026 129.807 57.1529 130.175 62.6662H114.164Z"
        fill={textColor}
      />
      <path
        d="M9.81543 141.206H17.4224L23.9251 119.643L29.8757 141.206H37.4213L47.4821 109.167H40.2433L33.5565 132.323L27.2992 109.167H21.1032L14.2937 132.323L7.91369 109.167H0L9.81543 141.206Z"
        fill={textColor}
      />
      <path
        d="M59.2968 103.899C61.7506 103.899 63.7137 102.062 63.7137 99.6724C63.7137 97.2221 61.7506 95.3843 59.2968 95.3843C56.8429 95.3843 54.8798 97.2221 54.8798 99.6724C54.8798 102.062 56.8429 103.899 59.2968 103.899ZM55.6773 141.206H63.1003V109.167H55.6773V141.206Z"
        fill={textColor}
      />
      <path
        d="M74.4874 141.206H81.9103V122.338C81.9103 117.254 85.2844 114.681 89.4559 114.681C93.8729 114.681 95.8359 116.886 95.8359 121.725V141.206H103.259V121.052C103.259 112.23 98.7192 108.494 92.2779 108.494C87.0021 108.494 83.444 111.128 81.9103 114.252V109.167H74.4874V141.206Z"
        fill={textColor}
      />
      <path
        d="M125.07 141.757C127.339 141.757 128.934 141.389 130.1 140.961V135.08C129.057 135.509 127.953 135.692 126.481 135.692C124.149 135.692 122.8 134.406 122.8 131.588V114.742H129.855V109.167H122.8V102.123H115.377V109.167H111.083V114.742H115.377V132.262C115.377 138.326 118.69 141.757 125.07 141.757Z"
        fill={textColor}
      />
      <path
        d="M153.245 141.818C161.465 141.818 166.925 138.143 167.968 131.404H160.79C160.238 134.528 157.907 136.305 153.429 136.305C147.907 136.305 144.84 132.874 144.595 126.81H168.09V124.666C168.09 113.211 160.913 108.494 152.938 108.494C143.797 108.494 136.988 115.11 136.988 125.033V125.523C136.988 135.631 143.797 141.818 153.245 141.818ZM144.717 121.848C145.454 116.886 148.46 113.884 152.938 113.884C157.539 113.884 160.361 116.335 160.729 121.848H144.717Z"
        fill={textColor}
      />
      <path
        d="M177.06 141.206H184.483V124.543C184.483 117.744 188.409 115.661 194.912 115.6V108.677C189.513 108.739 186.507 111.128 184.483 115.171V109.167H177.06V141.206Z"
        fill={textColor}
      />
      <path
        d="M3.19002 200.387H10.6129V181.214C10.6129 176.313 13.987 173.863 17.6678 173.863C21.2872 173.863 23.373 175.884 23.373 180.601V200.387H30.7959V181.214C30.7959 176.313 34.17 173.863 37.8508 173.863C41.5315 173.863 43.556 175.884 43.556 180.601V200.387H50.9789V180.111C50.9789 171.29 46.1939 167.675 40.3046 167.675C36.3171 167.675 31.9002 169.452 29.4463 173.434C27.8513 169.452 24.5386 167.675 20.367 167.675C15.6433 167.675 12.1466 170.248 10.6129 173.25V168.349H3.19002V200.387Z"
        fill={textColor}
      />
      <path
        d="M70.2481 201C75.1558 201 77.9777 199.223 80.0635 196.467V200.387H87.3637V179.376C87.3637 170.616 81.7199 167.675 74.5423 167.675C67.3648 167.675 61.4142 170.8 60.8007 178.273H67.9783C68.3463 175.088 70.2481 173.25 74.1129 173.25C78.4685 173.25 79.9408 175.394 79.9408 179.682V181.336H75.9533C66.7513 181.336 59.5125 184.031 59.5125 191.505C59.5125 198.182 64.3588 201 70.2481 201ZM72.0271 195.671C68.3463 195.671 66.874 193.894 66.874 191.199C66.874 187.278 70.4935 185.992 76.1373 185.992H79.9408V189.177C79.9408 193.281 76.5668 195.671 72.0271 195.671Z"
        fill={textColor}
      />
      <path
        d="M98.2112 200.387H105.634V183.725C105.634 176.925 109.56 174.843 116.063 174.781V167.859C110.665 167.92 107.659 170.31 105.634 174.353V168.349H98.2112V200.387Z"
        fill={textColor}
      />
      <path
        d="M124.934 200.387H132.356V184.644L144.38 200.387H152.969L139.473 183.051L151.926 168.349H143.828L132.356 182.439V153.525H124.934V200.387Z"
        fill={textColor}
      />
      <path
        d="M173.074 201C181.295 201 186.755 197.324 187.797 190.586H180.62C180.068 193.71 177.737 195.487 173.258 195.487C167.737 195.487 164.67 192.056 164.424 185.992H187.92V183.848C187.92 172.392 180.743 167.675 172.768 167.675C163.627 167.675 156.818 174.291 156.818 184.215V184.705C156.818 194.813 163.627 201 173.074 201ZM164.547 181.03C165.283 176.068 168.289 173.066 172.768 173.066C177.369 173.066 180.191 175.517 180.559 181.03H164.547Z"
        fill={textColor}
      />
      <path
        d="M207.81 200.939C210.079 200.939 211.674 200.571 212.84 200.142V194.262C211.797 194.69 210.693 194.874 209.221 194.874C206.889 194.874 205.54 193.588 205.54 190.77V173.924H212.595V168.349H205.54V161.305H198.117V168.349H193.823V173.924H198.117V191.444C198.117 197.508 201.43 200.939 207.81 200.939Z"
        fill={textColor}
      />
      <path
        d="M240 38.2778H216.968L231.464 23.803L227.598 19.9431L209.237 38.2778H201.667V31.6837L220.028 13.349L216.163 9.48904L201.667 23.9638V0H196.191V23.9638L181.695 9.48904L177.83 13.349L196.191 31.6837V38.2778H189.587L171.226 19.9431L167.361 23.803L181.856 38.2778H157.858V43.7461H181.856L167.361 58.2209L171.226 62.0808L189.587 43.7461H196.191V51.3052L177.83 69.6399L181.695 73.4999L196.191 59.0251V82.0239H201.667V59.0251L216.163 73.4999L220.028 69.6399L201.667 51.3052V43.7461H209.237L227.598 62.0808L231.464 58.2209L216.968 43.7461H240V38.2778Z"
        fill={snowflakeColor}
      />
    </SVGIcon>
  );
};
